<template>
    <div v-if="$parent.mediaProperty.configuration" class="configuration">
        <div class="formRow"><h4>Storyboard Id: </h4><input type="text" v-model="$parent.mediaProperty.configuration.storyboard_id" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive"/></div>
        <div class="output">
            <h4>Video Output:</h4>
            <div class="videoOutput" v-if="$parent.mediaProperty.configuration.output">
                <div class="outputRow" v-for="(videoOutputRow, index) in $parent.mediaProperty.configuration.output.video" :key="videoOutputRow.key">
                    <div class="formRow">
                        <h4>Video Type:</h4>
                        <select v-model="videoOutputRow.format" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive">
                            <option value="" selected disabled>Select a type</option>
                            <option value="mp4">MP4</option>
                            <option value="hls">HLS</option>
                        </select>
                        <p class="validationMessage" v-if="!videoOutputRow.format">*Video Type is required</p>
                    </div>
                    <div class="formRow">
                        <h4>Quality:</h4>
                        <input type="number" v-model="videoOutputRow.quality" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                        <p class="validationMessage" v-if="videoOutputRow.quality && (videoOutputRow.quality < 1 || videoOutputRow.quality > 50)">*Quality must be between 1 and 50</p>
                    </div>
                    <div class="formRow">
                        <h4>Height:</h4>
                        <input type="number" v-model="videoOutputRow.height" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                        <p class="validationMessage" v-if="!videoOutputRow.height && videoOutputRow.height !== 0">*Height is required</p>
                        <p class="validationMessage" v-if="(videoOutputRow.height || videoOutputRow.height === 0) && videoOutputRow.height <= 0">*Height must be positive</p>
                    </div>
                    <div class="formRow cropToRatio">
                        <h4>Crop To Ratio:</h4>
                        <input type="number" v-model="videoOutputRow.cropToRatio[0]" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                        <input type="number" v-model="videoOutputRow.cropToRatio[1]" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                        <p class="validationMessage" v-if="(videoOutputRow.cropToRatio[1] && videoOutputRow.cropToRatio[1] <= 0) || (videoOutputRow.cropToRatio[0] && videoOutputRow.cropToRatio[0] <= 0)">*Crop To Ratio must be positive</p>
                        <p class="validationMessage" v-if="(videoOutputRow.cropToRatio[0] && !videoOutputRow.cropToRatio[1]) || (!videoOutputRow.cropToRatio[0] && videoOutputRow.cropToRatio[1])">*Crop To Ratio must have two positive values</p>
                    </div>
                    <div class="formRow">
                        <h4>Suffix:</h4>
                        <input type="text" v-model="videoOutputRow.suffix" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                        <p class="validationMessage" v-if="videoOutputRow.suffix && !(/^[A-Za-z0-9]+$/.test(videoOutputRow.suffix))">*Only alphanumeric characters allowed</p>
                    </div>
                    <div class="formRow">
                        <h4>Overlay:</h4>
                        <input type="text" v-model="videoOutputRow.overlay" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                    </div>
                    <div class="formRow overlayAlignment">
                        <h4>Overlay Alignment:</h4>
                        <select v-model="videoOutputRow.overlayAlignment[0]" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive">
                            <option value="" selected disabled>Select an X value</option>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </select>
                        <select v-model="videoOutputRow.overlayAlignment[1]" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive">
                            <option value="" selected disabled>Select an Y value</option>
                            <option value="top">Top</option>
                            <option value="middle">Middle</option>
                            <option value="bottom">Bottom</option>
                        </select>
                    </div>
                    <div class="formRow">
                        <h4>Overlay Scale:</h4>
                        <select v-model="videoOutputRow.overlayScale" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive">
                            <option value="fit" selected>Fit</option>
                            <option value="fill">Fill</option>
                            <option value="none">None</option>
                        </select>
                    </div>
                    <div class="formRow">
                        <h4>Landing Page Id:</h4>
                        <input type="text" v-model="videoOutputRow.landingPageId" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                    </div>
                    <div class="formRow">
                        <h4>Label</h4>
                        <input type="text" v-model="videoOutputRow.label" @change="saveIdomooVideo" :disabled="!$parent.mediaProperty.isActive" />
                    </div>
                    <button class="deleteButton" @click="deleteVideoOutput(index)" :disabled="!$parent.mediaProperty.isActive">Delete Video Output</button>
                    <hr/>
                </div>
                <button class="addRowButton" @click="addVideoOutput" :disabled="!$parent.mediaProperty.isActive">Add Video Output</button>
            </div>
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';

export default {
    name: 'IdomooVideoEdit',
    data: function() {
        return {
            newOutput: {
                video: [{
                    key: 0,
                    format: '',
                    quality: 26,
                    height: 0,
                    cropToRatio: [null,null],
                    suffix: '',
                    overlay: '',
                    overlayAlignment: ['',''],
                    overlayScale: 'fit',
                    landingPageId: '',
                    label: ''
                }]
            } 
        }
    },
    beforeMount() {
        if(!this.$parent.mediaProperty.configuration) {
            this.$parent.mediaProperty.configuration = {
                storyboard_id: '',
                output: this.newOutput,
                data: []
            }
        } 
        
        if(!this.$parent.mediaProperty.configuration.output)
            this.$parent.mediaProperty.configuration.output = this.newOutput;

        for(let i = 0; i < this.$parent.mediaProperty.configuration.output.video.length; i++) {
            this.$parent.mediaProperty.configuration.output.video[i].key = i;
            if(!this.$parent.mediaProperty.configuration.output.video[i].cropToRatio)
                this.$parent.mediaProperty.configuration.output.video[i].cropToRatio = [null,null];
            if(!this.$parent.mediaProperty.configuration.output.video[i].overlayAlignment)
                this.$parent.mediaProperty.configuration.output.video[i].overlayAlignment = ['',''];
        }
    },
    computed: {
        validated() {
            let configuration = this.$parent.mediaProperty.configuration;
            let ret = true;

            for(let i = 0; i < configuration.output.video.length; i++) {
                let video = configuration.output.video[i];
                if(video.format.length === 0 ||
                    (video.quality && video.quality < 1) ||
                    (video.quality &&video.quality > 50) ||
                    !video.height ||
                    video.height <= 0 ||
                    (video.cropToRatio[0] && !video.cropToRatio[1]) || 
                    (!video.cropToRatio[0] && video.cropToRatio[1]) ||
                    (video.cropToRatio[0] && video.cropToRatio[0] <= 0) ||
                    (video.cropToRatio[1] && video.cropToRatio[1] <= 0) ||
                    (video.suffix && !(/^[A-Za-z0-9]+$/.test(video.suffix)))
                )
                ret = false;
            }

            return ret;
        }
    },
    methods: {
        saveIdomooVideo: async function() {
            if(this.validated) {
                const resp = this.processSaveResult(await data.saveMediaProperty(this.$parent.mediaProperty))
                if(!this.$parent.mediaProperty.id && resp.id) {
                    this.$parent.mediaProperty.id = resp.id;
                    this.$router.replace({path: this.$route.path, query: { ID: this.$parent.mediaProperty.id}});
                }
            } else {
                this.$toast.error('Idomoo Configuration Not Valid');
            }
        },
        addVideoOutput: function() {
            if(!this.$parent.mediaProperty.configuration.output) {
                this.$parent.mediaProperty.configuration.output = {};
            }
            let key = this.$parent.mediaProperty.configuration.output.video.length > 0 ? this.$parent.mediaProperty.configuration.output.video[this.$parent.mediaProperty.configuration.output.video.length - 1].key + 1 : 1;
            this.$parent.mediaProperty.configuration.output.video.splice(this.$parent.mediaProperty.configuration.output.video.length, 0, {
                format: '',
                quality: 26,
                height: 0,
                cropToRatio: [null,null],
                suffix: '',
                overlay: '',
                overlayAlignment: ['',''],
                overlayScale: 'fit',
                landingPageId: '',
                label: '',
                key: key
            });
            this.saveIdomooVideo();
        },
        deleteVideoOutput: function(rowIndex) {
            if(this.$parent.mediaProperty.configuration.output.video.length <= 1)
                this.$toast.error("Cannot delete the only video output");
            else {
                if(confirm('Are you sure you want to delete this video output?')) {
                    this.$parent.mediaProperty.configuration.output.video.splice(rowIndex, 1);
                    this.saveIdomooVideo();
                }
            }
        }
    }
}
</script>

<style scoped>
    h4 {
        display: inline-block;
        width: 200px;
    }
    hr {
        width: 100%;
        flex-basis: 100%;
        margin-top: 20px;
    }
    .videoOutput {
        margin-left: 20px;
        padding: 20px;
        background: rgb(240, 240, 240);
        border-radius: 10px;
    }
    .deleteButton {
        height: 40px;
        width: 150px;
        font-size: 16px;
        background-color: darkred;
        border-color: darkred;
        color: white;
        border-radius: 10px;
        display: flex;
        position: relative !important;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .deleteButton:disabled {
        cursor:default;
        color: gray;
    }
    .addRowButton {
        height: 40px;
        width: 150px;
        font-size: 16px;
        background-color: lightblue;
        border-color: lightblue;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .formRow {
        position: relative;
    }

    .formRow.cropToRatio input, .formRow.overlayAlignment select {
        margin-right: 20px;
    }

    .validationMessage {
        color: darkred;
        position: absolute;
        left: 200px;
        bottom: -20px;
        font-size: smaller;
    }
</style>